import React from 'react';
import { DollarSign, CheckCircle2, Clock, ShieldCheck } from 'lucide-react';
import { Header } from '../components/Header.js';
import { EduCard } from '../components/EduCard.js';
import { EduBadge } from '../components/EduBadge.js';

export const Payments: React.FC = () => {
  const dummyPayments = [
    {
      id: 'pay_01',
      customer: 'Instituto Saber Educacional',
      amount: 19900,
      dueDate: '2026-10-15',
      paidAt: '2026-10-10',
      status: 'paid',
      method: 'Boleto / Pix',
    },
    {
      id: 'pay_02',
      customer: 'Colégio Futuro Inteligente',
      amount: 49900,
      dueDate: '2026-10-20',
      paidAt: null,
      status: 'pending',
      method: 'Cartão de Crédito',
    },
  ];

  return (
    <div>
      <Header
        title="Gestão de Pagamentos"
        subtitle="Controle financeiro de faturas, liquidações e histórico de recebíveis"
      />

      <div className="p-8 max-w-7xl mx-auto space-y-6">
        <EduCard title="Faturas e Recebíveis de Assinatura">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-xs border-collapse">
              <thead>
                <tr className="border-b border-bdr text-txt-secondary font-semibold bg-surface-secondary">
                  <th className="py-3 px-4">Código</th>
                  <th className="py-3 px-4">Cliente</th>
                  <th className="py-3 px-4">Valor</th>
                  <th className="py-3 px-4">Vencimento</th>
                  <th className="py-3 px-4">Forma</th>
                  <th className="py-3 px-4">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-bdr text-txt-primary">
                {dummyPayments.map((p) => (
                  <tr key={p.id} className="hover:bg-surface-secondary/40">
                    <td className="py-3 px-4 font-mono font-semibold">{p.id}</td>
                    <td className="py-3 px-4 font-semibold">{p.customer}</td>
                    <td className="py-3 px-4 font-mono font-bold text-txt-primary">
                      R$ {(p.amount / 100).toFixed(2).replace('.', ',')}
                    </td>
                    <td className="py-3 px-4 font-mono text-txt-secondary">
                      {new Date(p.dueDate).toLocaleDateString('pt-BR')}
                    </td>
                    <td className="py-3 px-4 text-txt-secondary">{p.method}</td>
                    <td className="py-3 px-4">
                      {p.status === 'paid' ? (
                        <EduBadge variant="success" dot>Pago</EduBadge>
                      ) : (
                        <EduBadge variant="warning" dot>Pendente</EduBadge>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </EduCard>
      </div>
    </div>
  );
};
